import { Component } from '@angular/core';

@Component({
  selector: 'app-sealverification-dialog',
  templateUrl: './sealverification-dialog.component.html',
  styleUrls: ['./sealverification-dialog-component.scss']
})
export class SealverificationdialogComponent {

}
